import { render, staticRenderFns } from "./empowertype.vue?vue&type=template&id=1d9139be&scoped=true&"
import script from "./empowertype.vue?vue&type=script&lang=js&"
export * from "./empowertype.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./empowertype.vue?vue&type=style&index=1&id=1d9139be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9139be",
  null
  
)

export default component.exports